export default __webpack_public_path__ + "static/tanecni-kurzy-4-93bc58b377e2a0d2d59eb68c58d6b057.jpg";